module.exports = __webpack_public_path__ + "static/media/home-grey.0a4cf50d.svg";